const LABELS = {
    "blossom-gold": { ar: "ذهب وزهر", en: "Gold and blossom" },
    "sage-garden": { ar: "حديقة هادئة", en: "Quiet garden" },
    "midnight-velvet": { ar: "ليل مخملي", en: "Velvet night" },
    "desert-dune": { ar: "رمل دافئ", en: "Warm sand" },
    "coastal-linen": { ar: "كتان وبحر", en: "Linen and sea" },
    "royal-majlis": { ar: "مجلس ملكي", en: "Royal majlis" },
    "cherry-blossom": { ar: "زهر الكرز", en: "Cherry blossom" },
    "olive-grove": { ar: "زيتون نهاري", en: "Daylight olive" },
    "art-deco-night": { ar: "ليل آرت ديكو", en: "Art deco night" },
    "lavender-field": { ar: "حقل خزامى", en: "Lavender field" },
    "monochrome-ink": { ar: "حبر وورق", en: "Ink and paper" },
    "ruby-banquet": { ar: "ياقوت فاخر", en: "Ruby banquet" },
    "moroccan-lantern": { ar: "فانوس مغربي", en: "Moroccan lantern" },
    "winter-white": { ar: "أبيض شتوي", en: "Winter white" },
    "sunset-terrace": { ar: "شرفة الغروب", en: "Sunset terrace" },
    "forest-chapel": { ar: "غابة هادئة", en: "Forest chapel" },
    "porcelain-blue": { ar: "خزف أزرق", en: "Porcelain blue" },
    "modern-gallery": { ar: "معرض حديث", en: "Modern gallery" },
    "pearl-blush": { ar: "لؤلؤ وخجل", en: "Pearl and blush" },
    "nile-papyrus": { ar: "بردي النيل", en: "Nile papyrus" },
};

export const PALETTE_KEYS = ["bg", "primary", "accent", "rose", "leaf"];

export const SAMPLE_MARK = "نموذج للعرض / Sample";

export const GALLERY_TITLE = "Wedding themes";

export const GALLERY_DESCRIPTION =
    "Sample wedding invitation themes for Youssef & Layla at Jasmine Hall in Cairo. نموذج للعرض.";

export function themeLabel(theme) {
    return LABELS[theme?.id] || { ar: theme?.name || "", en: theme?.name || "" };
}

export function previewTitle(theme) {
    return `${theme.name} wedding theme`;
}

export function previewDescription(theme) {
    return `Sample ${theme.name} wedding invitation for Youssef & Layla at Jasmine Hall in Cairo. نموذج للعرض.`;
}

// A missing cover keeps the live couple photo off this sample and shows the monogram.
export const SAMPLE_WEDDING = {
    groom_en: "Youssef",
    bride_en: "Layla",
    groom_ar: "يوسف",
    bride_ar: "ليلى",
    date_iso: "2027-05-14T19:30:00+03:00",
    venue_en: "Cairo",
    venue_ar: "القاهرة",
    hall_en: "Jasmine Hall",
    hall_ar: "قاعة الياسمين",
    city_en: "Egypt",
    city_ar: "مصر",
    address_en: "Cairo, Egypt",
    address_ar: "القاهرة، مصر",
    maps_url: "https://www.google.com/maps/search/?api=1&query=Cairo%20Egypt",
    maps_embed: "https://maps.google.com/maps?q=Cairo%20Egypt&z=11&output=embed",
    note_en: "Sample",
    note_ar: "نموذج للعرض",
    cover_image_url: "/sample-invitation/no-photo",
};

export const SAMPLE_GUEST = {
    name: "ضيف",
    english_name: "Guest",
};
